import { useEffect, useState } from "react"
import ItemDTO from "../../DTO/ItemDTO"
import { GenericDTO } from "../../DTO/GenericDTO"
import { EventDTO } from "../../DTO/EventDTO"
import { LexwareButtonType, LexwareDTO } from "../../DTO/LexwareDTO"
import { Check, DollarSign, DownloadCloud, Edit3, Plus, Tag, UploadCloud, X, XCircle } from "react-feather"
import lexwareLogo from '../../../assets/lexware/LexwareLogo.svg'
import lexwareLogoBlack from '../../../assets/lexware/LexwareLogoBlack.svg'
import InputB from "../../../components/InputB/InputB"
import { Button, ButtonGroup } from "@mui/material"
import SellIcon from '@mui/icons-material/Sell';
import EuroIcon from '@mui/icons-material/Euro';
import CloseIcon from '@mui/icons-material/Close';




export function LexwareButton(props: {
  item: ItemDTO | GenericDTO | EventDTO,
  kind: LexwareButtonType,
  reloadTrigger?: () => void,
  displayBillList?: boolean,
  className?: string,
  personId?: string,
  buttonSizes?: string,
}) {
  const [rerender, setRerender] = useState(0)
  const lexwareLogoSize = props.buttonSizes || '20px'
  function reloadButton() {
    setRerender(rerender + 1)
  }
  const [lexware] = useState(new LexwareDTO({
    item: props.item,
    reloadTrigger: props.reloadTrigger,
    kind: props.kind,
    personId: props.personId,
    // reloadButton: () => {reloadButton()},
  }))

  const [renameItem, setRenameItem] = useState('')
  useEffect(() => {
    lexware.reram(props.item)
  }, [lexware, props.item])
      // <img style={{height: lexwareLogoSize}} src={lexwareLogo} alt="LexwareLogo" className="lexwareLogo" />

  function LexwareButtons() {
    return <>
      <ButtonGroup
        sx={{marginBottom: '16px', marginTop: '16px'}}
        >
        {
          lexware.doDisplay('lexwareLogo') &&
          <Button
            disabled={true}
          >
            <img style={{height: lexwareLogoSize}} src={lexwareLogo} alt="LexwareLogo" className="lexwareLogo" />
          </Button>
        }
        {
          lexware.doDisplay('transferToLexware') &&
          <Button
            variant="outlined"
            title='Auf Lexware übertragen'
            onClick={async () => {
              await lexware.doTransfer()
              reloadButton()
            }}
          >
            {
              lexware.resourceUri ?
              <img style={{height: lexwareLogoSize}} src={lexwareLogo} alt="LexwareLogo" className="lexwareLogo" />
              :
              <img style={{height: lexwareLogoSize}} src={lexwareLogoBlack} alt="LexwareLogo" className="lexwareLogo" />
            }
          </Button>
        }
        {
          props.displayBillList && lexware.doDisplay('removeLexwareConnection') &&
          <Button
            title='Verbindung zu Lexware trennen'
            onClick={async () => {
              if(!window.confirm('Soll die Verbindung zu Lexware wirklich getrennt werden?')) return;
              
              await lexware.removeLexwareConnection()
              reloadButton()
            }}
          ><CloseIcon /></Button>
        }
        {
          lexware.doDisplay('createBill') &&
          <>
            <Button
              title='Angebot schreiben'
              variant="outlined"
              onClick={async () => {
                await lexware.createBill('offer')
                reloadButton()
              }}
            ><SellIcon sx={{fontSize: lexwareLogoSize}}/></Button>
            <Button
              title='Rechnung schreiben'
              onClick={async () => {
                await lexware.createBill('bill')
                reloadButton()
              }}
            // eslint-disable-next-line react/jsx-no-undef
            ><EuroIcon sx={{fontSize: lexwareLogoSize}}/></Button>
          </>
        }
      </ButtonGroup>
    </>
  }
  // Modus if we do not have the list:
  if (!props.displayBillList) {
    return <LexwareButtons />
  }
  // Modus for displaying everything:
  return <div className={props.className || ''}>
    <div>
      <LexwareButtons />
    </div>
    {
      props.displayBillList &&
      <table>
        <tbody>
        {
          lexware.getBillList().map((billItem, index) => <tr
            key={billItem.key}
          >
            <td>
              {
                billItem.billType === 'bill' && <DollarSign />
              }
              {
                billItem.billType === 'offer' && <Tag />
              }
            </td>
            <td title='Rechnungsnummer'>
              <i>
                {billItem.voucherNumber}
              </i>
            </td>
            <td>
              {
                renameItem === billItem.key ?
                <InputB
                  returnVal={(newVal) => {
                    lexware.saveBillName(billItem.key, newVal)
                    setRenameItem('')
                  }}
                  value={billItem.name}
                  delay={-1}
                  sendButton={`Speichern`}
                /> :
                <span>{billItem.name}</span>
              }
            </td>
            <td>
              ({lexware.paymentStatus2Human(billItem.paymentStatus)})
            </td>
            <td>
              {billItem.humanDate}
            </td>
            <td>
              {
                renameItem === billItem.key ? 
                <button
                  className={`w3-button`}
                  title='Umbenennen Abbrechen'
                  onClick={() => {
                    setRenameItem('')
                  }}
                ><XCircle /></button>
                :
                <button
                  className={`w3-button`}
                  title='Umbenennen'
                  onClick={() => {
                    setRenameItem(billItem.key)
                  }}
                ><Edit3 /></button>
              }
            </td>
            <td>
              <button
                className={`w3-button`}
                title='Status von Lexware abrufen'
                onClick={async () => {
                  await lexware.getBillStatus(billItem.resourceUri)
                  reloadButton()
                }}
              ><DownloadCloud /></button>
            </td>
            <td>
              <button
                className={`w3-button`}
                title='Verbindung lösen'
                onClick={async () => {
                  if (window.confirm('Verbindung wirklich lösen?')) {
                    await lexware.removeBill(billItem.resourceUri)
                    reloadButton()
                  }
                }}
              ><X /></button>
            </td>
          </tr>)
        }
        </tbody>
      </table>
    }
  </div>
}
